import { LanguageObject } from "@redux/services/types";

/**
 * Retrieves text for a specific language from an array of LanguageObject
 * @param languageObjects - Array of LanguageObject containing text in different languages
 * @param targetLanguage - The language code to look for (e.g., 'en', 'fr', 'es')
 * @param mapDefaultLanguage - Optional map default language to use as fallback
 * @returns The text in the target language, or the map default language as fallback, or undefined if array is empty/null
 */
export const getTextByLanguage = (
  languageObjects: LanguageObject[] | null | undefined,
  targetLanguage: string,
  mapDefaultLanguage?: string,
): string | undefined => {
  if (!languageObjects || languageObjects.length === 0) {
    return undefined;
  }

  // First, try to find the exact language match
  const targetMatch = languageObjects.find(
    (obj) => obj.lang === targetLanguage,
  );

  if (targetMatch) {
    return targetMatch.text;
  }

  // If map default language is provided, try to find it as fallback
  if (mapDefaultLanguage) {
    const defaultMatch = languageObjects.find(
      (obj) => obj.lang === mapDefaultLanguage,
    );

    if (defaultMatch) {
      return defaultMatch.text;
    }
  }

  // Return undefined if neither target nor default language found
  return undefined;
};
